// Character Information Page Translation
export default {
  // Input placeholders
  placeholders: {
    name: "Enter name",
    homePlace: "Enter hometown",
    suspicionLevel: "Select suspicion level",
    idNumber: "Enter ID number",
    role: "Enter role",
    phone: "Enter phone numbers, separated by commas",
    email: "Enter emails, separated by commas",
    caseSearch: "Search and select cases by name, multiple selections allowed",
    surveySearch:
      "Search and select survey users by ID, multiple selections allowed",
    traceJudgment: "Enter trace judgment",
    infoStreamJudgment: "Enter information flow judgment",
    assetJudgment: "Enter asset flow judgment",
    phoneListInfo: "Enter phone list information",
    companyUnderName: "Select company status",
    actualControlAddress: "Enter actual control address",
    chineseIdentity: "Enter identity",
    remark: "Enter remark",
    region: "Select region",
  },

  // Buttons
  buttons: {
    reset: "Reset",
    search: "Search",
    addCharacter: "+ Add Character",
    view: "View",
    delete: "Delete",
    cancel: "Cancel",
    confirm: "Confirm",
    edit: "Edit",
    save: "Save",
    duplicateCheck: "Check Duplicate",
    goEdit: "Go to Edit",
  },

  // Statistics
  statistics: {
    total: "Total",
    totalData: "records",
  },

  // Table column headers
  table: {
    name: "Name",
    homePlace: "Hometown",
    suspicionLevel: "Suspicion Level",
    traceJudgment: "Trace Judgment",
    infoStreamJudgment: "Info Stream Judgment",
    assetJudgment: "Asset Judgment",
    sourceType: "Data Source",
    updateTime: "Update Time",
    action: "Action",
  },

  // Dialog titles
  dialogs: {
    detail: "Character Details",
    create: "Add Character",
    edit: "Edit Character",
    deleteConfirm: "Confirm",
    deleteMessage:
      "This will permanently delete {name}'s character information. Are you sure?",
    duplicateWarning: "Warning",
    duplicateMessage:
      'The ID number already exists for character "{name}". Do you want to edit this character information?',
  },

  // Form labels
  labels: {
    name: "Name",
    region: "Region",
    suspicionLevel: "Suspicion Level",
    idNumber: "ID Number",
    homePlace: "Hometown",
    role: "Role",
    phone: "Phone",
    email: "Email",
    gcCase: "GC Case",
    backendCase: "Backend Case",
    relatedSurvey: "Related Survey",
    traceJudgment: "Trace Judgment",
    infoStreamJudgment: "Info Stream Judgment",
    assetJudgment: "Asset Judgment",
    phoneListInfo: "Phone List Info",
    companyUnderName: "Company",
    actualControlAddress: "Actual Control Address",
    chineseIdentity: "Chinese Identity",
    remark: "Remark",
    updateTime: "Update Time",
    lastOperator: "Last Operator",
    sourceType: "Data Source",
    // Edit page specific labels (Survey/Manual classification)
    phoneSurvey: "Phone (Survey)",
    phoneManual: "Phone (Manual)",
    emailSurvey: "Email (Survey)",
    emailManual: "Email (Manual)",
    gcCaseSurvey: "GC Case (Survey)",
    gcCaseManual: "GC Case (Manual)",
    relatedSurveySurvey: "Related Survey (Survey)",
    relatedSurveyManual: "Related Survey (Manual)",
  },

  // Messages
  messages: {
    noData: "No data",
    loading: "Loading",
    deleteSuccess: "Deleted successfully!",
    deleteCancelled: "Delete cancelled",
    createSuccess: "Created successfully!",
    createFailed: "Create failed!",
    editSuccess: "Edited successfully!",
    editFailed: "Edit failed!",
    saveFailed: "Save failed, please try again later",
    checkFailed: "Check failed, please try again later",
    enterIdFirst: "Please enter ID number first",
    fetchFailed: "Failed to fetch character information",
  },
};
